<template>
  <div class="interface-area listing">
    <div class="transaction-box">
      <div class="text-area">
        <h1>
          {{ $t('listing.listing') }}
        </h1>
        <p class="desc">
          {{ $t('listing.listing_desc') }}
        </p>
        <div class="buttons-area">
          <button v-if="user !== undefined && user !== null" type="button" class="btn cyan" @click="scrolltoForm('new')">
            {{ $t('listing.create_new') }}
          </button>
          <button v-else type="button" class="btn pink" @click="openConnectModal">
            {{ $t('common.connect_wallet') }}
          </button>
          <button v-if="user !== undefined && user !== null" type="button" class="btn pink" @click="scrolltoForm('exists')">
            {{ $t('listing.add_by_address') }}
          </button>
        </div>
      </div>
      <div class="image-area">
        <div class="picture">
          <picture>
            <source srcset="/img/new/coins/left-2.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              src="/img/new/coins/left-2.png"
              alt="Deposit USDT and buy $DFP to invest n Defi Pool Finance"
              title="Invest in $DFP"
              loading="lazy"
              placeholder
              :quality="80"
            />
          </picture>
        </div>
      </div>
    </div>
    <div class="listing-area">
      <div class="preview-area">
        <div class="preview-title">
          {{ $t('listing.preview') }}
        </div>
        <div class="image-area">
          <nuxt-img
            :src="$getImage(form.image)"
            :alt="form.name !== null && form.name.length > 0 ? form.name + ' crypto token creation and sell fo free on DefiPool' : 'Creating new crypto token with price for the makret on Defi Pool'"
            :title="form.name !== null && form.name.length > 0 ? form.name : 'New ERC20 token on Defi Pool'"
            fit="inside"
            loading="lazy"
            placeholder
            @error="$event.target.src = require('~/static/img/default_token.svg')"
          />
        </div>
        <div class="text-area">
          <div class="title">
            {{ form.name !== null && form.name.length > 0 ? form.name : $t('listing.new_token') }}
            ({{ form.symbol !== null && form.symbol.length > 0 ? form.symbol : $t('listing.new_token_symbol') }})
          </div>
          <div class="value-area">
            <span class="value">
              {{ form.decimals !== null && form.decimals.length > 0 ? form.decimals : '18' }}
            </span>
            <span class="desc">
              {{ $t('listing.decimals_word') }}
            </span>
          </div>
          <div v-if="form.hard_cap !== null && form.hard_cap.toString().length > 0" class="value-area">
            <span class="value">
              {{ $priceFormat(form.hard_cap, 0) }}
            </span>
            <span class="desc">
              {{ $t('listing.hard_cap_word') }}
            </span>
          </div>
          <div v-if="form.address !== null && form.address.length > 0 && $isAddress(form.address)" class="chain-explorer">
            <a :href="$getExplorerUserLink(form.address)" rel="nofollow noopener noreferrer" target="_blank">
              {{ $t('listing.view_on_explorer') }}
              <i class="bx bx-link-external"></i>
            </a>
          </div>
        </div>
      </div>
      <div ref="listingForm" class="listing-form">
        <div class="form-area">
          <div v-if="form.method === 'new' && form.step === 1" class="form-content create-token">
            <div class="title">
              {{ $t('listing.create_new_header') }}
            </div>
            <div class="desc">
              {{ $t('listing.create_new_desc') }}
            </div>
            <div class="input-area">
              <p class="input-header">
                {{ $t('listing.name') }}
                <span class="required">
                  *
                </span>
              </p>
              <div class="input-container">
                <input v-model="form.name" type="text" class="input">
                <p v-if="errors.name.length > 0" class="hint error">
                  {{ errors.name }}
                </p>
              </div>
            </div>
            <div class="input-area">
              <p class="input-header">
                {{ $t('listing.symbol') }}
                <span class="required">
                  *
                </span>
              </p>
              <div class="input-container">
                <input v-model="form.symbol" type="text" class="input">
                <p v-if="errors.symbol.length > 0" class="hint error">
                  {{ errors.symbol }}
                </p>
              </div>
            </div>
            <div class="input-area">
              <p class="input-header">
                {{ $t('listing.decimals') }}
                <span class="required">
                  *
                </span>
                <span class="hint wide-tooltip" :tooltip="$t('listing.decimals_tip')">
                  <i class="bx bxs-info-circle"></i>
                </span>
              </p>
              <div class="input-container">
                <input v-model="form.decimals" type="number" class="input">
                <p v-if="errors.decimals.length > 0" class="hint error">
                  {{ errors.decimals }}
                </p>
              </div>
            </div>
            <div class="input-area">
              <p class="input-header">
                {{ $t('listing.hard_cap') }}
                <span class="hint wide-tooltip" :tooltip="$t('listing.hard_cap_tip')">
                  <i class="bx bxs-info-circle"></i>
                </span>
              </p>
              <div class="input-container">
                <input v-model="form.hard_cap" type="number" class="input">
                <p v-if="errors.hard_cap.length > 0" class="hint error">
                  {{ errors.hard_cap }}
                </p>
                <p v-if="form.hard_cap !== null && form.hard_cap.length > 0 && parseInt(form.hard_cap, 10) !== 0" class="hint info">
                  {{ $t('listing.hard_cap_notice') }}
                </p>
              </div>
            </div>
            <div class="buttons-area">
              <button v-if="user !== null" type="button" :class="{'btn pink': true, 'disabled': form.loading}" :disabled="form.loading" @click="deployToken">
                <span v-if="!form.loading">
                  {{ $t('listing.deploy') }}
                </span>
                <span v-else>
                  <i class="bx bx-loader-alt loading"></i>
                </span>
              </button>
              <button v-else class="btn pink" @click="openConnectModal">
                {{ $t('common.connect_wallet') }}
              </button>
            </div>
          </div>
          <div v-if="form.method === 'exists' && form.step === 1" class="form-content add-token">
            <div class="title">
              {{ $t('listing.add_by_address_header') }}
            </div>
            <div class="desc">
              {{ $t('listing.add_by_address_desc') }}
            </div>
            <div class="input-area">
              <p class="input-header">
                {{ $t('listing.address') }}
                <span class="required">
                  *
                </span>
              </p>
              <div class="input-container">
                <input v-model="form.address" type="text" class="input" @input="checkAddressField">
                <p v-if="errors.address.length > 0" class="hint error">
                  {{ errors.address }}
                </p>
                <p v-if="form.address !== null && form.address.length > 0" class="hint info">
                  {{ $t('listing.add_by_address_notice') }}
                </p>
              </div>
            </div>
            <div class="buttons-area">
              <button v-if="user !== null" type="button" :class="{'btn pink': true, 'disabled': hasErrors || form.loading}" :disabled="hasErrors || form.loading" @click="checkErc20Address">
                <span v-if="!form.loading">
                  {{ $t('listing.fetch') }}
                </span>
                <span v-else>
                  <i class="bx bx-loader-alt loading"></i>
                </span>
              </button>
              <button v-else class="btn pink" @click="openConnectWallet">
                {{ $t('common.connect_wallet') }}
              </button>
            </div>
          </div>
          <div v-if="form.step === 2" class="form-content image">
            <div class="title">
              {{ $t('listing.upload_image') }}
            </div>
            <div class="desc">
              {{ $t('listing.upload_image_desc') }}
            </div>
            <div class="image-area">
              <client-only>
                <FilePond
                  ref="image"
                  class="filepond"
                  :label-idle="$t('listing.image_placeholder')"
                  :allow-multiple="false"
                  :allow-process="false"
                  accepted-file-types="image/jpeg, image/png, image/gif, image/webp"
                  max-file-size="2MB"
                  :label-max-file-size-exceeded="$t('listing.media_is_too_large')"
                  :label-max-file-size="$t('listing.max_file_size', { max: '2MB' })"
                  :server="imageServerOptions"
                  :files="fileImage"
                  @init="initImage"
                  @initfile="activateImageDelete"
                  @removefile="deactivateImageDelete"
                />
              </client-only>
            </div>
            <p class="desc">
              JPG, PNG, GIF, WEBP. {{ $t('listing.max_size') }}: 2 MB
            </p>
            <label v-if="imageCanDelete" class="delete-area">
              <button type="button" class="btn cyan smaller" @click="emptyImage">
                {{ $t('listing.delete_image') }}
              </button>
            </label>
            <div class="buttons-area">
              <button v-if="user !== null" type="button" :class="{'btn pink': true, 'disabled': hasErrors || form.loading}" :disabled="hasErrors || form.loading" @click="goNextPage">
                <span v-if="!form.loading">
                  {{ $t('listing.next') }}
                </span>
                <span v-else>
                  <i class="bx bx-loader-alt loading"></i>
                </span>
              </button>
            </div>
          </div>
          <div v-if="form.step === 3" class="form-content liquidity">
            <div class="title">
              {{ $t('listing.add_liquidity_header') }}
            </div>
            <div class="desc">
              {{ $t('listing.add_liquidity_desc') }}
            </div>
            <div class="buttons-area">
              <button type="button" :class="{'btn pink': true, 'disabled': hasErrors || form.loading}" :disabled="hasErrors || form.loading" @click="fixTokenToLiquidity">
                <span>
                  {{ $t('listing.add_liquidity') }}
                </span>
              </button>
            </div>
          </div>
          <div v-if="form.step === 4" class="form-content success">
            <div class="title">
              {{ $t('listing.success', { token: form.name }) }} 🎉
            </div>
            <div class="desc">
              {{ $t('listing.success_desc') }}
            </div>
            <div class="buttons-area">
              <nuxt-link :to="localePath('/swap')" :class="{'btn pink': true, 'disabled': hasErrors || form.loading}" :disabled="hasErrors || form.loading">
                <span>
                  {{ $t('listing.continue_to_site') }}
                </span>
              </nuxt-link>
            </div>
          </div>
        </div>
        <div class="steps">
          <div v-for="ind in steps" :key="ind" :class="{'step': true, 'active': form.step === ind}">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import VueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

const FilePond = VueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileValidateSize)

export default {
  name: 'ListNewCoinComponent',
  components: {
    FilePond
  },
  layout: 'new',
  data() {
    const that = this
    return {
      steps: 3,
      form: {
        step: 1,
        method: 'new',
        name: null,
        symbol: null,
        decimals: 18,
        hard_cap: null,
        address: null,
        image: null,
        loading: false
      },
      errors: {
        address: '',
        name: '',
        symbol: '',
        hard_cap: '',
        decimals: ''
      },
      fileImage: [],
      imageCanDelete: false,
      imageServerOptions: {
        url: process.env.apiUrl,
        process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
          this.form.loading = true
          const bodyFormData = new FormData()
          bodyFormData.append('file', file)
          bodyFormData.append('action', 'upload')
          bodyFormData.append('mid', 1)
          bodyFormData.append('identity', this.form.address)

          this.$nuxt.$emit('openLoading', this.$t('listing.uploading'), this.$t('listing.uploading_desc'))
          this.uploadTokenImage(bodyFormData).then((response) => {
            this.$nuxt.$emit('openSuccess', this.$t('listing.uploaded'), this.$t('listing.uploaded_desc'))
            this.form.image = response.answer.path
            load(response.answer.path)
            this.form.loading = false
            this.$nuxt.$emit('closeCommonModals')
          }).catch((err) => {
            console.log(err)
            this.$nuxt.$emit('closeCommonModals')
            error(err)
            this.form.loading = false
          })
        },
        load(source, load, error, progress, abort, headers) {
          if (source !== null) {
            that.$load.$get('media', {
              params: {
                filepath: source
              }
            }).then((response) => {
              const fileType = (/[.]/.exec(source)) ? /[^.]+$/.exec(source) : undefined
              const newBlob = new Blob([response], { type: 'image/' + fileType[0] })
              load(newBlob)
            }).catch((err) => {
              error(err)
            })
          }
        }
      }
    }
  },
  async fetch({ store, error, route }) {
    try {
      const pageName = route.name.split('___')
      const seoData = store.getters['seos/seosByUri'](pageName[0])
      if (seoData === null) {
        await store.dispatch('seos/fetchSeos', {
          uri: route.name
        })
      }
    } catch (err) {
      error(err)
    }
  },
  head({ $config: { appUrl } }) {
    return {
      title: this.meta ? this.meta.title : this.$t('common.launching'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-description',
          name: 'og:description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-title',
          name: 'og:title',
          content: this.meta
            ? this.meta.title
            : this.$t('common.launching')
        },
        {
          hid: 'og-image',
          name: 'og:image',
          content: this.meta
            ? this.meta.image
            : appUrl + 'seo/default.jpg'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta ? this.meta.keyword : ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters('seos', [
      'seosByUri'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('tokens', [
      'token'
    ]),
    meta() {
      const pageName = this.$nuxt.$route.name.split('___')
      return this.seosByUri(pageName[0])
    },
    hasErrors() {
      return this.errors.name.length > 0 || this.errors.decimals.length > 0 || this.errors.address.length > 0 ||
        this.errors.hard_cap.length > 0 || this.errors.symbol.length > 0
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('modal', [
      'changeModalWalletState'
    ]),
    ...mapActions('tokens', [
      'uploadTokenImage',
      'fetchToken',
      'createToken'
    ]),
    openConnectModal() {
      this.changeModalWalletState({
        state: true
      })
    },
    scrolltoForm(method = 'new') {
      this.form.method = method
      // if (this.$refs.listingForm !== undefined && this.$refs.listingForm !== null) {
      //   window.scrollTo({
      //     top: this.$refs.listingForm.offsetTop + window.innerHeight,
      //     behavior: 'smooth'
      //   })
      // }
    },
    async deployToken() {
      await this.clearErrors()
      await this.checkCreationForm()
      if (this.hasErrors) {
        return
      }
      try {
        this.$nuxt.$emit('openLoading', this.$t('listing.deploying_token'), this.$t('listing.deploying_token_desc'))
        const userAddress = await this.$getUserAddress()
        if (userAddress.length === 0) {
          return
        }
        const factoryFile = await import('~/assets/abis/ERC20Factory.json')
        const factory = factoryFile.default
        const factoryContract = new window.eth.eth.Contract(factory, this.$config.erc20Factory)

        const feeRequired = await factoryContract.methods.fee().call({ from: userAddress })

        const decimalsToContractValue = this.form.decimals !== null && this.form.decimals.length > 0 ? this.form.decimals : '18'
        const capToContractValue = this.form.hard_cap !== null && this.form.hard_cap.length > 0 ? window.eth.utils.toWei(this.form.hard_cap) : '0'

        const gasPrice = await this.$calculateGasCost()
        const gasFeeEstimated = await factoryContract.methods.deployNewERC20(this.form.name, this.form.symbol, decimalsToContractValue, capToContractValue)
          .estimateGas({ from: userAddress, value: feeRequired, gas: 5000000 })

        factoryContract.methods.deployNewERC20(this.form.name, this.form.symbol, decimalsToContractValue, capToContractValue)
          .send({ from: userAddress, value: feeRequired, gas: Math.round(gasFeeEstimated * 1.1), gasPrice })
          .then(async (result) => {
            const tokenAddress = result.events.tokenDeployed.returnValues.token
            this.form.address = tokenAddress
            this.form.step += 1
            this.form.loading = false
            await this.createToken({
              bid: this.$config.chainId,
              hash: result.transactionHash,
              gasUsed: result.gasUsed,
              transactionIndex: result.transactionIndex,
              tx_title: this.$t('listing.create_token', { token: this.form.name }),
              ...this.form
            })
            this.$nuxt.$emit('closeCommonModals')
          })
          .catch((err) => {
            this.$nuxt.$emit('openError', this.$t('common.deined_operation'))
            console.log(err)
          })
      } catch (err) {
        console.log(err)
        this.$nuxt.$emit('openError', this.$t('listing.error_creating'), this.$t('listing.error_creating_desc'))
      }
    },
    checkCreationForm() {
      if (this.form.name === null || this.form.name.length === 0 || this.form.name.length > 75) {
        this.errors.name = this.$t('listing.form_name_error')
      }
      if (this.form.symbol === null || this.form.symbol.length === 0 || this.form.symbol.length > 15) {
        this.errors.symbol = this.$t('listing.form_symbol_error')
      }
      if (this.form.decimals === null || isNaN(this.form.decimals) || parseInt(this.form.decimals, 10) > 30) {
        this.errors.decimals = this.$t('listing.form_decimals_error')
      }
      if (this.form.hard_cap !== null && this.form.hard_cap.length > 0 && !isNaN(this.form.hard_cap)) {
        const roundedHardCap = this.form.hard_cap.includes('.') ? this.form.hard_cap.split('.')[0] : this.form.hard_cap
        const currentHardCap = window.eth.utils.toBN(window.eth.utils.toWei(roundedHardCap))
        const maxHardCap = window.eth.utils.toBN('115792089237316195423570985008687907853269984665640564039457584007913129639935')
        this.errors.hard_cap = currentHardCap.gt(maxHardCap) ? this.$t('listing.form_hard_cap_error') : ''
      } else if (isNaN(this.form.hard_cap)) {
        this.errors.hard_cap = this.$t('listing.form_hard_cap_error')
      }
    },
    checkAddressField() {
      this.errors.address = ''
      if (this.form.address.length > 0 && !this.$isAddress(this.form.address)) {
        this.errors.address = this.$t('listing.form_address_error')
      }
    },
    clearErrors() {
      this.errors = {
        address: '',
        name: '',
        symbol: '',
        hard_cap: '',
        decimals: ''
      }
    },
    initImage() {
      if (this.$refs.image !== undefined && this.form.image !== 'default.jpg' && this.form.image !== null) {
        this.$refs.image.addFile(this.form.image, { type: 'local' })
      }
    },
    activateImageDelete() {
      this.imageCanDelete = true
    },
    deactivateImageDelete() {
      this.imageCanDelete = false
    },
    async emptyImage() {
      if (this.$refs.image !== undefined) {
        this.$refs.image.removeFile()
      }
      if (this.form.image !== null) {
        this.form.loading = true
        const bodyFormData = new FormData()
        bodyFormData.append('action', 'image_delete')
        bodyFormData.append('mid', 1)
        bodyFormData.append('identity', this.form.address)

        try {
          await this.uploadTokenImage(bodyFormData)
          this.form.image = null
          this.form.loading = false
        } catch (err) {
          console.log(err)
          this.form.loading = false
        }
      }
    },
    async checkErc20Address() {
      this.errors.address = ''
      this.$nuxt.$emit('openLoading', this.$t('listing.fetching_header'), this.$t('listing.fetching_desc'))
      let saveToken = false
      try {
        await this.fetchToken({
          address: this.form.address
        })
        this.form.image = this.token.logoURI !== null ? this.token.logoURI : null
      } catch (err) {
        saveToken = true
        console.log(err)
      }
      try {
        const userAddress = await this.$getUserAddress()
        if (userAddress.length === 0) {
          return
        }
        const erc20File = await import('~/assets/abis/ERC20DPToken.json')
        const erc20 = erc20File.default
        const erc20Contract = new window.eth.eth.Contract(erc20, this.form.address)
        const cap = await erc20Contract.methods.getCap().call({ from: userAddress })
        this.form.hard_cap = parseFloat(window.eth.utils.fromWei(cap))
      } catch (err) {
        console.log(err)
      }
      try {
        const userAddress = await this.$getUserAddress()
        if (userAddress.length === 0) {
          return
        }
        const erc20File = await import('~/assets/abis/ERC20DPToken.json')
        const erc20 = erc20File.default
        const erc20Contract = new window.eth.eth.Contract(erc20, this.form.address)

        await erc20Contract.methods.balanceOf(userAddress).call({ from: userAddress })
        await erc20Contract.methods.allowance(userAddress, this.form.address).call({ from: userAddress })

        this.form.name = await erc20Contract.methods.name().call({ from: userAddress })
        this.form.symbol = await erc20Contract.methods.symbol().call({ from: userAddress })
        const decimals = await erc20Contract.methods.decimals().call({ from: userAddress })
        this.form.decimals = parseFloat(decimals)
        const owner = await erc20Contract.methods.owner().call({ from: userAddress })
        if (owner === userAddress || (this.token !== null && this.token.user_address === userAddress)) {
          if (saveToken) {
            this.createToken({
              bid: this.$config.chainId,
              ...this.form
            })
          }
          this.form.step += 1
          this.initImage()
          this.$nuxt.$emit('closeCommonModals')
        } else {
          this.$nuxt.$emit('closeCommonModals')
          this.errors.address = this.$t('listing.you_not_owner')
        }
      } catch (err) {
        this.$nuxt.$emit('closeCommonModals')
        this.errors.address = this.$t('listing.form_address_error')
        console.error(err)
      }
    },
    goNextPage() {
      this.form.step += 1
    },
    async fixTokenToLiquidity() {
      await this.$router.push({
        path: this.localePath('/liquidity/add'),
        query: {
          to: this.form.address,
          toStatus: 'fixed'
        }
      })
    }
  }
}
</script>

<style scoped>
  @import url('~/assets/css/new/listing.css');
</style>
